import 'react-popper-tooltip/dist/styles.css';
import './styles.scss';

import { useEffect, useMemo, useRef } from 'react';

import classNames from 'classnames';
import { createPortal } from 'react-dom';
import type { Config } from 'react-popper-tooltip';
import { usePopperTooltip } from 'react-popper-tooltip';

import type { PopperTooltipProps } from './types';

export function PopperTooltip(props: PopperTooltipProps) {
  const {
    dataTestId,
    className,
    wrapperClassName,
    isBig,
    content,
    children,
    offset = [22, 5],
    handleEvents,
    trigger = 'click',
    placement = 'bottom-end',
    container,
  } = props;

  const MAX_WIDTH_CONTAINER = 425;
  const isWidthLowerThanMaxWidthContainer = window.innerWidth <= MAX_WIDTH_CONTAINER;

  const setTriggerRefContainer = useRef(null);

  const config = useMemo(() => {
    const isMobile = window.innerWidth <= 767;
    const mobileOffset = [isMobile ? offset[0] / 2 : offset[0], offset[1]];

    return {
      trigger,
      placement,
      offset: mobileOffset,
    };
  }, [offset, trigger, placement]);

  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip(config as Config);

  const isBigContainer = isBig ? 'tooltip-container tooltip-container--is-big' : 'tooltip-container';
  const tooltipClassname = !isWidthLowerThanMaxWidthContainer
    ? isBigContainer
    : `${isBigContainer} tooltip-container--is-mobile`;

  useEffect(() => {
    if (visible && handleEvents) {
      handleEvents();
    }
  }, [visible, handleEvents]);

  return (
    <div className={wrapperClassName}>
      <div ref={setTriggerRef} className="tooltip__icon" data-testid={dataTestId}>
        {children}
      </div>
      {visible &&
        createPortal(
          <div
            ref={setTooltipRef}
            {...getTooltipProps({
              className: classNames(tooltipClassname, className),
            })}
          >
            <div ref={setTriggerRefContainer}>{content}</div>
            <div style={{ marginRight: '10px' }}>
              <div
                {...getArrowProps({
                  className: 'tooltip-arrow',
                })}
              />
            </div>
          </div>,
          container || document.body,
        )}
    </div>
  );
}
